import type { ReactNode } from 'react'
import { useAuth } from '../lib/auth'

export function ProductAnalyticsAccess({ children }: { children: ReactNode }) {
  const auth = useAuth()
  if (
    auth.status !== 'authenticated' ||
    !auth.user.is_product_analytics_reader
  ) {
    return (
      <div
        className="rounded-lg border border-destructive/40 bg-destructive/5 p-6"
        role="alert"
        data-testid="product-analytics-forbidden"
      >
        <h1 className="text-lg font-semibold">Brak dostępu</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Ten panel wymaga dedykowanego uprawnienia wewnętrznego analityka
          Archigma. Rola właściciela lub administratora organizacji nie daje
          dostępu.
        </p>
      </div>
    )
  }
  return children
}
